import service from '@/store/services/licences-service';

const state = {
    list: {},
    licence: {},
    availableLicences: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, licence) => {
        state.licence = licence;
    },
    SET_LICENCES_COUNT: (state, availableLicences) => {
        state.availableLicences = availableLicences;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    getAvailableLicencesCount({ commit, dispatch }, params) {
        return service.getAvailableLicencesCount(params)
            .then((role) => { commit('SET_LICENCES_COUNT', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((licence) => { commit('SET_RESOURCE', licence); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((licence) => { commit('SET_RESOURCE', licence); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    licence: state => state.licence,
    availableLicences: state => state.availableLicences,
    dropdown: (state) => {
        return state.list.map(licence => ({
            id: licence.id,
            name: licence.name
        }));
    }
};

const licences = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default licences;